import type { PosState } from './pos.slice';

// Open bonuri survive a refresh — a dedicated POS terminal shouldn't lose every
// open table to an accidental reload. Best-effort: any storage/parse error just
// falls back to a fresh state.
const KEY = 'pos-state-v1';

export function loadPosState(): PosState | undefined {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return undefined;
        const parsed = JSON.parse(raw) as PosState;
        if (!parsed || !Array.isArray(parsed.tabs) || parsed.tabs.length === 0) return undefined;
        if (!parsed.tabs.some((t) => t.id === parsed.activeTabId)) {
            parsed.activeTabId = parsed.tabs[0].id;
        }
        return parsed;
    } catch {
        return undefined;
    }
}

export function savePosState(state: PosState): void {
    try {
        localStorage.setItem(KEY, JSON.stringify(state));
    } catch {
        // quota / serialization — persistence is best-effort, ignore.
    }
}
